import React from 'react';
import HollowButtonDark from './ui-components/hollowButtonDark';
import {StaticImage} from 'gatsby-plugin-image';
import SectionLayout from '../layouts/section-layout';
import {motion} from 'framer-motion';
import {sectionLayoutChildAnimation} from '../utils/animations';

export default function Section1() {
  return (
    <SectionLayout>
      <div className="pb-16 mb-16  border-b-2 border-gray-300">
        <motion.div
          variants={sectionLayoutChildAnimation}
          className="max-w-2xl mx-auto pt-6 text-center  "
        >
          <p className="my-1 text-3xl  text-gray-600 font-bold">
            Join The Movement: Empowering Adaptive Hiking, One Trail at a Time.
          </p>
          <p className="my-1  text-lg  font-normal text-gray-700 ">
            Smartphone-Powered Trail Assessment Data.
          </p>
        </motion.div>
        <motion.div variants={sectionLayoutChildAnimation}>
          <StaticImage
            className="flex justify-center my-10  "
            style={{ maxHeight: '370px' }}
            src="../assets/images/hero.png"
            alt="a map photo"
          />
        </motion.div>
        <motion.div
          variants={sectionLayoutChildAnimation}
          className="my-1 mb-1 flex gap-10 justify-center"
        >
          <a href={'https://testflight.apple.com/join/KAEYkxGW'} target={'_blank'} rel={'noreferrer'}>
            <HollowButtonDark>Discover Adapt</HollowButtonDark>
          </a>
          <a href={'mailto:jon@neotreks.com'}>
            <HollowButtonDark>Contact Sales</HollowButtonDark>
          </a>
        </motion.div>
      </div>
    </SectionLayout>
  );
}
